var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('ProductDescription'),(!_vm.stock._id)?_c('Preloader'):_c('PrizeList',{attrs:{"title":_vm.stock.name,"description":_vm.stockDate,"items":_vm.prizesBySelectedStock},on:{"play":_vm.onClickPlay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }